module.exports = __webpack_public_path__ + "fd5a608a/img/09000000-3.19ea5255.png";